import { loadRefsOut } from '../common/api';

const model = {
    name: 'referredout',
    state: { 
        names: [], 
        current: {
            details: {}
        },
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.roid
            }
        },
        cdcInsert: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.roid]: { ...payload.cdc }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.roid]: {
                        ...state.byId[payload.roid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.roid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        loadedRefsOut: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadRefsOut( { aid, uid } ) {
            const list = await loadRefsOut( aid, uid );
            let byId = {};
            list.forEach( r => byId[r.roid] = r );
            dispatch.referredout.loadedRefsOut( byId );
        },
        insert( { roid, cdc } ) {
            dispatch.referredout.cdcInsert( { roid, cdc } );
        },
        modify( { roid, cdc } ) {
            dispatch.referredout.cdcModify( { roid, cdc } );
        },
        remove( { roid } ) {
            dispatch.referredout.cdcRemove( { roid } );
        },
        setCurrent( { roid } ) {
            dispatch.referredout.setCurrentId( { roid } );
        }
    } )
}

export default model;